module.exports = __webpack_public_path__ + "img/Group 1031seven.40f3bf96.png";